<div class="container">
   
    <div class="body">
        <app-btn-actualizar-info style="float: right;"></app-btn-actualizar-info>
        <div class="row">
            <div class="col">
                Carta
                <select [(ngModel)]="tipo_carta" (change)="GetCarta()">
                    <option value="0">Selecciona la carta a descargar</option>
                    <option value="17">Aprobada</option>
                    <option value="18">Visita</option>
                    <option value="19">Videollamada</option>
                    <option value="20">Documentación</option>
                    <option value="21">Aval</option>
                    <option value="22">Rechazada</option>
                </select>
            </div>
        </div>

        <div *ngIf="tipo_carta == 20" class="row">
            <div class="col">
                <label for="Documentos">Describe a continuación</label>
                <textarea name="Documentos" id="" cols="50" rows="4" [(ngModel)]="documentos"></textarea>
                <button class="principal_button" style="margin-top: 8px;" (click)="GetCarta()">Obtener carta</button>
            </div>
        </div>

        <div style="display: flex; justify-content: center;">
            <mat-spinner *ngIf="obteniendo_carta" diameter="20"></mat-spinner>
            <div *ngIf="src != null" style="background-color: grey; width: 100%;">
                <pdf-viewer *ngIf="src != null" [src]="src" style="border: 1px solid silver;"
                    [zoom]="1"
                ></pdf-viewer>
            </div>

        </div>

    </div>

    <!-- <div class="carta">
        <div class="doc" *ngIf="carta > 0">
            <div class="header">
                <img src="https://leaseforu-assets.s3.us-east-2.amazonaws.com/assets/images/logo-header.svg" height="40px" alt="">
                <h2>{{ carta == 4 ? 'Nos vemos a la próxima' : '¡Felicidades!'}}</h2>
                <hr style="border-color: #4fc7b7;">
            </div>
            <div class="body" *ngIf="carta == 4">
                <div style="width: 100%; text-align:right;">Fecha de envio: {{ fecha | date:'dd/MM/yyyy'}}</div>
                <p>Hola {{cliente}}</p>
                <p>Le informamos que tu solicitud de arrendamiento fue revisada en Comité de crédito y, tras evaluar el resultado del analisis realizado, se determinó <span class="color">no autorizar la operación.</span></p>
                <p>La solicitud no cumple con los elementos necesarios de acuerdo a nuestras politicas de crédito.</p>
                <div style="min-height: 300px;"></div>
            </div>
            <div class="body" *ngIf="carta < 4">
                <div style="width: 100%; text-align:right;">Fecha de envio: {{ fecha | date:'dd/MM/yyyy'}}</div>
                <p>Hola {{cliente}}</p>
                <p>El equipo de Lease For U agradece la confianza por habernos elegido como su herramienta financiera para hacer crecer su práctica/negocio.</p>
                <p>Te informamos con gusto que su solicitud de arrendamiento <span class="color">ha sido {{ carta == 1 ? 'autorizada' : carta == 2 ? 'autorizada condicionalmente' : 'pre autorizada'}}</span> dentro del Comité de Crédito bajo los siguientes términos.</p>
                <span><img style="vertical-align: middle;" src="https://static.api.leaseforu.com/assets/list_style.png" alt=""> Equipo: {{ DetalleCarta.tipo_activo_arrendar}}, {{DetalleCarta.descripcion_activo}}</span>
                <span><img style="vertical-align: middle;" src="https://static.api.leaseforu.com/assets/list_style.png" alt=""> Monto autorizado: $ {{ DetalleCarta.monto_arrendar | number:'1.2-2'}}</span>
                <table class="resumen">
                    <thead>
                        <tr>
                            <td><b>Plazo</b></td>
                            <td><b>{{DetalleCarta.plazo}} Meses</b></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><span>Comisión por apertura (2%)</span></td>
                            <td><span class="border">$ {{ DetalleCarta.comision | number:'1.2-2' }}</span></td>
                        </tr>
                        <tr>
                            <td><span>Renta Inicial</span></td>
                            <td><span class="border">$ {{ DetalleCarta.renta_inicial | number:'1.2-2'}}</span></td>
                        </tr>
                        <tr>
                            <td><span>IVA</span></td>
                            <td><span class="border">$ {{ DetalleCarta.iva | number:'1.2-2'}}</span></td>
                        </tr>
                        <tr>
                            <td style="text-align: right;"><span class="color">TOTAL PAGO INICIAL</span></td>
                            <td><span class="border grey">$ {{ DetalleCarta.total_pago_inicial | number:'1.2-2'}}</span></td>
                        </tr>
                        <tr>
                            <td><span>Renta mensual</span></td>
                            <td><span class="border">$ {{ DetalleCarta.renta_mensual | number:'1.2-2'}}</span></td>
                        </tr>
                        <tr>
                            <td><span>Seguro</span></td>
                            <td><span class="border">$ {{ DetalleCarta.seguro | number:'1.2-2'}}</span></td>
                        </tr>
                        <tr>
                            <td><span>IVA</span></td>
                            <td><span class="border">$ {{ DetalleCarta.iva2 | number:'1.2-2'}}</span></td>
                        </tr>
                        <tr>
                            <td style="text-align: right;"><span class="color">TOTAL RENTA INICIAL</span></td>
                            <td><span class="border grey">$ {{ DetalleCarta.total_renta_mensual | number:'1.2-2'}}</span></td>
                        </tr>
                    </tbody>
                </table>
                <table class="resumen">
                    <tbody>
                        <tr>
                            <td><span>Numero de mensualidades pendientes</span></td>
                            <td><span class="border small color">{{ DetalleCarta.plazo }}</span></td>
                        </tr>
                        <tr>
                            <td><span>Opción de compra (IVA incluido)</span></td>
                            <td><span class="border small color">$ {{ DetalleCarta.opcionCompraIVA | number:'1.2-2'}}</span></td>
                        </tr>
                    </tbody>
                </table>

                <div *ngIf="carta == 1" style="text-align: left; font-size: 1rem;" class="texto-carta">
                    <p>En los próximos días procederemos con el envío físico y/o digitalmente de su contrato con las instrucciones para firma, así como una guía prepagada de mensajería para poder enviarnos el documento firmado a nuestras oficinas.</p>
                </div>

                <div *ngIf="carta == 2 || carta == 3" style="text-align: left; font-size: 1rem;" class="texto-carta">
                    <p>Para concluir el proceso solicitamos su apoyo con el envío de los siguientes documentos:</p>
                    <p>{{condicion}}</p>
                    <p>Una vez recibida y validada la documentación de forma satisfactoria procederemos con el envío físico y/o digitalmente de su contrato.</p>
                </div>

                

            </div>
            <div class="footer-carta">
                <h3>¡ENCANTADOS DE AYUDARTE!</h3>
                <p>En caso de que tengas alguna duda o comentario contactanos en:</p>

                <div class="row">
                    <div class="col-2 center">
                        <div>
                            <img height="60px" width="auto" style="vertical-align: middle;" src="https://static.api.leaseforu.com/assets/email.png" alt="">
                            <span>nirvana@leaseforu.com</span>
                        </div>
                    </div>
                    <div class="col-2 center">
                        <div>
                            <img height="60px" width="auto" style="vertical-align: middle;" src="https://static.api.leaseforu.com/assets/phone.png" alt="">
                            <span>55 1832 68 53</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->

    <button *ngIf="src != null" mat-icon-button (click)="GuardarCarta()" [disabled]="pdf">
        <svg  style="height: 60px; width:auto;" xmlns="http://www.w3.org/2000/svg" width="116.322" height="116.322" viewBox="0 0 116.322 116.322"><defs><style>.a{fill:#00a5da;}.b{fill:#fff;}</style></defs><g transform="translate(-902 -3389)"><g transform="translate(739 1848)"><path class="a" d="M58.161,0A58.161,58.161,0,1,1,0,58.161,58.161,58.161,0,0,1,58.161,0Z" transform="translate(163 1541)"/></g><g transform="translate(896.596 3947.768)"><path class="b" d="M41.4-500.669q0-10.725,0-21.45a5.963,5.963,0,0,1,4.633-6.142,6.565,6.565,0,0,1,1.48-.165q10.753-.015,21.506-.009a1.767,1.767,0,0,1,1.333.539q7.188,7.155,14.4,14.284a2.217,2.217,0,0,1,.688,1.678q0,11.805,0,23.611c0,3.1.011,6.208-.006,9.312a5.921,5.921,0,0,1-4.568,5.912,7.2,7.2,0,0,1-1.645.175q-15.825.016-31.649.008a5.957,5.957,0,0,1-6.169-6.137c-.014-6.374,0-12.748,0-19.122v-2.494Zm25.685-24.262c-.148-.019-.22-.036-.292-.036q-9.671,0-19.342,0A2.322,2.322,0,0,0,45-522.431q0,21.753,0,43.507a2.643,2.643,0,0,0,.1.761,2.374,2.374,0,0,0,2.567,1.667q12.553,0,25.106,0c2.18,0,4.36.008,6.54,0a2.2,2.2,0,0,0,2.425-2.341q0-15.435-.006-30.87c0-.179-.017-.357-.028-.579h-.917c-2.586,0-5.173.011-7.759,0a5.9,5.9,0,0,1-5.841-4.915,11.06,11.06,0,0,1-.1-1.819C67.083-519.649,67.089-522.271,67.089-524.931Zm3.577,2.755.11-.152c-.006.122-.016.243-.016.365,0,1.845-.008,3.69,0,5.535a2.4,2.4,0,0,0,2.662,2.675c1.79.01,3.579,0,5.369,0,.141,0,.282-.022.6-.049Z"/><path class="b" d="M112.862-402.662a20.413,20.413,0,0,1,3.467.541,5.619,5.619,0,0,1,3.76,6.088,5.838,5.838,0,0,1-4.969,5.135,34.168,34.168,0,0,1-4.2.1,1.094,1.094,0,0,1-1.112-1.2q-.012-4.652,0-9.3a1.129,1.129,0,0,1,1.259-1.22c.591-.008,1.182,0,1.772,0Zm-.617,2.613v6.977c.7,0,1.359.009,2.02,0a3.353,3.353,0,0,0,3.414-2.793,3.427,3.427,0,0,0-2.6-4A17.845,17.845,0,0,0,112.245-400.049Z" transform="translate(-51.359 -94.439)"/><path class="b" d="M73.008-401.922a31.835,31.835,0,0,1,4.288.037,3.9,3.9,0,0,1,3.213,4.357,3.981,3.981,0,0,1-3.85,3.59c-.419.019-.839,0-1.311,0v3.741h-2.34Zm2.355,5.573c.459,0,.863.011,1.266,0a1.572,1.572,0,0,0,1.533-1.394A1.558,1.558,0,0,0,77-399.417a9.164,9.164,0,0,0-1.641-.019Z" transform="translate(-23.73 -94.95)"/><path class="b" d="M164.64-402.1v2.4h-4.906v2.322h4.444V-395h-4.466v4.724h-2.38v-1.6q0-4.348,0-8.7c0-1.141.384-1.529,1.516-1.528C160.764-402.1,162.68-402.1,164.64-402.1Z" transform="translate(-87.046 -94.862)"/></g></g></svg>
    </button>
    <button class="next-button" mat-button (click)="Save()">
        Finalizar
        <svg style="height: 20px; width:auto;"  xmlns="http://www.w3.org/2000/svg" width="31.25" height="31.25" viewBox="0 0 31.25 31.25"><defs><style>.next{fill:#00a5da;}</style></defs><path class="next" d="M15.625,0A15.625,15.625,0,1,0,31.25,15.625,15.626,15.626,0,0,0,15.625,0Zm-1.3,24.74V12.173L8.755,17.741l-2.21-2.21,9.079-9.081,9.081,9.081-2.21,2.21-5.569-5.568V24.74Z" transform="translate(31.25) rotate(90)"/></svg>
    </button>
    <app-socials-footer style="width: 100%;"></app-socials-footer>
</div>